'use client';

import { t } from '@lingui/macro';
import NewReleasesTwoToneIcon from '@mui/icons-material/NewReleasesTwoTone';
import { Box, Button, Tooltip } from '@mui/material';
import { useUsermaven } from '@prismo-io/tracking';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { type ComponentProps, type FC, type PropsWithChildren, useCallback } from 'react';
type Props = Omit<ComponentProps<typeof Button>, 'onClick' | 'href'>;
export const CheckListOpenButton: FC<PropsWithChildren<Props>> = props => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const usermaven = useUsermaven();
  const onOpen = useCallback(() => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('mode', 'analyse');
    router.push(`${pathname}?${params.toString()}`, {
      scroll: false
    });
    usermaven.track('analyze-guide-aura');
  }, [router, pathname, searchParams, usermaven]);
  return <Box component="div" position="relative" data-sentry-element="Box" data-sentry-component="CheckListOpenButton" data-sentry-source-file="open-btn.tsx">
      {/* TODO: A retiré quand la fonctionnalité ne sera plus nouvelle */}
      <Box component="div" position="absolute" top="-.5rem" right="-.5rem" data-sentry-element="Box" data-sentry-source-file="open-btn.tsx">
        <Tooltip title={t`Nouvelle fonctionnalité`} placement="top" data-sentry-element="Tooltip" data-sentry-source-file="open-btn.tsx">
          <NewReleasesTwoToneIcon color="primary" data-sentry-element="NewReleasesTwoToneIcon" data-sentry-source-file="open-btn.tsx" />
        </Tooltip>
      </Box>
      <Button onClick={onOpen} {...props} data-sentry-element="Button" data-sentry-source-file="open-btn.tsx" />
    </Box>;
};